import MfaChoice from 'creative-ui/oktaComponents/MfaChoice';
import CardBtn from 'creative-ui/uikit/CardBtn';
import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import maskGroupSvg from '@/assets/mask-group.svg';
import smartphoneMobileSvg from '@/assets/smartphone-mobile.svg';
import Flex from '@/components/Layout/Flex/Flex';
import Text from '@/components/Typography/Text/Text';

import { useMfaBeginEnrollOptionsManager } from '../hooks/useMfaBeginEnrollOptionsManager';

function MfaBeginEnrollOptionsForm() {
  const { t } = useTranslation('mfaBeginEnrollOptions');
  const { handleEnrollSms, handleIgnore, texts, supportedEnrolledFactors } =
    useMfaBeginEnrollOptionsManager();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const ignoreText = t('button.ignore');

  const onEnrollSms = async () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    try {
      await handleEnrollSms();
    } finally {
      setIsSubmitting(false);
    }
  };

  const onIgnore = async () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    try {
      await handleIgnore();
    } finally {
      setIsSubmitting(false);
    }
  };

  const title = texts?.title || t('header.title');
  const description = texts?.description || t('header.description');

  const cardConfig: Record<
    string,
    { img: string; title: string; text: string }
  > = {
    sms: {
      img: smartphoneMobileSvg,
      title: t('cards.sms.title'),
      text: t('cards.sms.description'),
    },
  };
  const cards = supportedEnrolledFactors.map((factor) => {
    const config = cardConfig[factor];

    return (
      <CardBtn
        key={factor}
        title={
          config?.title ?? t(`factors.${factor}`, { defaultValue: factor })
        }
        text={config?.text ?? t(`factors.${factor}`, { defaultValue: '' })}
        img={config?.img}
        onClick={() => onEnrollSms()}
      />
    );
  });

  return (
    <>
      <MfaChoice
        title={title}
        introText={description}
        cards={cards}
        modal={{
          label: t('modal.label'),
          modalContent: (
            <>
              <p className="u-heading-3 u-textCenter u-margin-b-l">
                {t('modal.title')}
              </p>
              <Flex justify="center" direction="row" align="center">
                <img alt="" src={maskGroupSvg} />
              </Flex>
              <div className="c-wysiwyg">
                <Text>{t('modal.description')}</Text>
                <Text>{t('modal.intro')}</Text>
                <ul>
                  <li className="u-list__item u-theme-color-before">
                    {t('modal.reasons.firstLogin')}
                  </li>
                  <li className="u-list__item u-theme-color-before">
                    {t('modal.reasons.newDevice')}
                  </li>
                  <li className="u-list__item u-theme-color-before">
                    {t('modal.reasons.privateBrowser')}
                  </li>
                  <li className="u-list__item u-theme-color-before">
                    {t('modal.reasons.newCountry')}
                  </li>
                </ul>
              </div>
            </>
          ),
        }}
      />
      <CtaContainer stack>
        <Cta type="ghost" onClick={onIgnore} disabled={isSubmitting}>
          {ignoreText}
        </Cta>
      </CtaContainer>
    </>
  );
}

export default MfaBeginEnrollOptionsForm;
